import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnTick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M20 5 8.571 19 4 13.4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnTick;
